import Repository from "./Repository";

const GET_ALL = "/coachdate/getcoachdate";
const GET_ALL_ANN = "/coachannounce/getcoachannounce";
const EDIT_COACH_ANN = "/coachannounce/editcoachannounce";
const CREATE = "/coachform/createcoachform";
const CREATE_SESSION = "/coachdate/createcoachdate";
const GET_COACH = "/coachdate/getcoachdate";
const DELETE_SESSION = "/coachdate/deletecoachdate";
const EDIT_SESSION = "/coachdate/editcoachdate";
const CREATE_BROCHURE = "/Brochure/createBrochure";
const GET_BROCHURE = "/Brochure/get";
const EDIT_BROCHURE = "/Brochure/edit";
const DELETE_BROCHURE = "/Brochure/delete";

export default {
  getcoachtable(payload) {
    return Repository.get(transformRoute(GET_ALL));
  },
  getcoachannonce(payload) {
    return Repository.get(transformRoute(GET_ALL_ANN));
  },
  editcoachannounce(payload) {
    return Repository.post(transformRoute(EDIT_COACH_ANN), payload);
  },
  getcoachform(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  Sessiondate(payload) {
    return Repository.post(transformRoute(CREATE_SESSION), payload);
  },
  GetSession(payload) {
    return Repository.get(transformRoute(GET_COACH), payload);
  },
  DeleteSession(payload) {
    return Repository.post(transformRoute(DELETE_SESSION), payload);
  },
  EditSession(payload) {
    return Repository.post(transformRoute(EDIT_SESSION), payload);
  },
  CreateBrochure(payload) {
    return Repository.post(transformRoute(CREATE_BROCHURE), payload);
  },
  GetBrochure(payload) {
    return Repository.post(transformRoute(GET_BROCHURE), payload);
  },
  EditBrochure(payload) {
    return Repository.post(transformRoute(EDIT_BROCHURE), payload);
  },
  DeleteBrochure(payload) {
    return Repository.post(transformRoute(DELETE_BROCHURE), payload);
  },
};
const transformRoute = (route) => {
  return `/coach${route}`;
};
